import axios from "axios";
import LZString from 'lz-string';
import {
  API_BASE_URL,
  API_BASE_URL1,
  API_BASE_URL3,
} from "../Services/baseApiUrl";
import axiosInstance from "../../Hooks/axoisInstance";
//const countryId =localStorage.getItem("country_Id");
import { toast } from "react-toastify";
const getToken = () => {
  return localStorage.getItem("token");
};

export const AllVehicleDetails = async () => {
  try {
    const response = await axios.get(
      API_BASE_URL3 + `MasterDetails/GetAllVehicleDetails`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
    
  } catch (error) {
    throw error;
  }
};
// export const AllVehicleDetails = async () => {
//   const cacheKey = "allVehicleDetails";
//   const cacheExpiryKey = "allVehicleDetailsExpiry";
//   const cacheExpiryTime = 2 * 60 * 1000; // 10 minutes in milliseconds

//   // Retrieve the cached data and its expiry time
//   const cachedData = sessionStorage.getItem(cacheKey);
//   const cachedExpiryTime = sessionStorage.getItem(cacheExpiryKey);

//   // Check if the cached data exists and is still valid
//   if (cachedData && cachedExpiryTime) {
//     const now = new Date().getTime();

//     if (now < parseInt(cachedExpiryTime)) {
//       // Decompress and return the cached data if valid
//       const decompressedData = LZString.decompress(cachedData);
//       return JSON.parse(decompressedData);
//     } else {
//       // Remove the cached data if expired
//       sessionStorage.removeItem(cacheKey);
//       sessionStorage.removeItem(cacheExpiryKey);
//     }
//   }

//   try {
//     // If there's no valid cached data, make the API call
//     const response = await axiosInstance.get( API_BASE_URL3 + `MasterDetails/GetAllVehicleDetails`, {
//       headers: {
//         Authorization: `Bearer ${getToken()}`
//       }
//     });

//     // Compress and store the data in session storage along with the current timestamp
//     const compressedData = LZString.compress(JSON.stringify(response.data));
//     sessionStorage.setItem(cacheKey, compressedData);
//     sessionStorage.setItem(cacheExpiryKey, new Date().getTime() + cacheExpiryTime);

//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

export const AddVehicleDetails = async (vehicleData) => {
  try {
    const response = await axiosInstance.post(
      API_BASE_URL3 + `MasterCreate/AddNewVehicle`,
      vehicleData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    // const successMessage = 'New Vehicle Added Successfully'
    // toast.success(successMessage, {
    //   position: 'top-right',
    //   autoClose: 3000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   progress: undefined,
    // })

    return response;
  } catch (error) {
    throw error;
  }
};

export const UpdateVehicleDetails = async (vehicleData) => {
  try {
    const response = await axiosInstance.put(
      API_BASE_URL3 + `MasterCreate/UpdateVehicleDetails`,
      vehicleData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    // const successMessage = 'Vehicle Details Updated Successfully'
    // toast.success(successMessage, {
    //     position: 'top-right',
    //     autoClose: 3000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    // })

    // if (!response.ok) {
    //   throw new Error("Failed to add Vehicle");
    // }

    return response;
  } catch (error) {
    throw error;
    // throw new Error("Error adding Vehicle: " + error.message);
  }
};

export const AllVehicleTypeDetails = async () => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 + `MasterDetails/GetAllVehicleTypeDetails`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    const data = response.data;
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.data)) return data.data;
    if (Array.isArray(data?.result)) return data.result;
    return [];
  } catch (error) {
    throw error;
  }
};

export const CreateVehicleTypeDetails = async (vehicleTypeData) => {
  try {
    const response = await axiosInstance.post(
      API_BASE_URL1 + `MasterCreate/AddNewVehicleType`,
      vehicleTypeData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const UpdateVehicleTypeDetails = async (vehicleTypeData) => {
  try {
    const response = await axiosInstance.put(
      API_BASE_URL1 + `MasterCreate/UpdateVehicleTypeDetails`,
      vehicleTypeData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const AllVehicleCategoryDetails = async () => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `vehcile/categories`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getVehicleById = async (id) => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `vehcile/getById/${id}`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    // console.log(response, 'response')
    return response;
  } catch (error) {
    throw error;
  }
};

export const getVehicleTypeById = async (id) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 + `vehcile_type/getById/${id}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    // console.log(response, 'response')
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllVehicleDetailsByFilters = async (zoneId,circleId,collectionTypeId,VehicleTypeId,ownerTypeId,vehicleNumber) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 + `MasterDetails/GetAllVehicleDetailsByFilters?zoneId=${zoneId}&CircleId=${circleId}&CollectionTypeId=${collectionTypeId}&vehicleTypeId=${VehicleTypeId}&OwnerTypeId=${ownerTypeId}&VehicleNumber=${vehicleNumber}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    // console.log(response, 'response')
    return response;
  } catch (error) {
    throw error;
  }
};

export const AllVehicleStatusDetails = async () => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 + `MasterDetails/GetAllVehicleStatus`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const AllVehicleCapacityDetails = async () => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 + `MasterDetails/GetAllVehicleCapacityDetail`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    const data = response.data;
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.data)) return data.data;
    if (Array.isArray(data?.result)) return data.result;
    return [];
  } catch (error) {
    throw error;
  }
};

export const CreateVehicleCapacityDetails = async (vehicleCapacity) => {
  try {
    const response = await axiosInstance.post(
      API_BASE_URL1 + `MasterCreate/AddNewVehicleCapacity`,
      vehicleCapacity,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const UpdateVehicleCapacityDetails = async (vehicleCapacity) => {
  try {
    const response = await axiosInstance.put(
      API_BASE_URL1 + `MasterCreate/UpdateVehicleCapacity`,
      vehicleCapacity,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetAllVehicleTypeByCollectionType = async (requestData) => {
  const token = localStorage.getItem("token");
  try {
    const { CollectionTypeId } = requestData;
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `MasterDetails/GetAllVehicleTypeByCollectionType?CollectionTypeId=${CollectionTypeId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetAllVehicleCapacityByVehicleType = async (requestData) => {
  const token = localStorage.getItem("token");
  try {
    
    const { VehicleTypeId } = requestData;
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `MasterDetails/GetAllVehicleCapacityByVehicleType?VehicleTypeId=${VehicleTypeId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        },
      
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetAllVehicleFuelType = async (requestData) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 + `MasterDetails/GetAllFuelType`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
// export const GetAllVehicleFuelType = async () => {
//   const cacheKey = "getAllVehicleFuelType";
//   const cacheExpiryKey = "getAllVehicleFuelTypeExpiry";
//   const cacheExpiryTime = 10 * 60 * 1000; // 10 minutes in milliseconds

//   // Retrieve the cached data and its expiry time
//   const cachedData = sessionStorage.getItem(cacheKey);
//   const cachedExpiryTime = sessionStorage.getItem(cacheExpiryKey);

//   // Check if the cached data exists and is still valid
//   if (cachedData && cachedExpiryTime) {
//     const now = new Date().getTime();

//     if (now < parseInt(cachedExpiryTime)) {
//       return JSON.parse(cachedData); // Return the cached data if valid
//     } else {
//       // Remove the cached data if expired
//       sessionStorage.removeItem(cacheKey);
//       sessionStorage.removeItem(cacheExpiryKey);
//     }
//   }

//   try {
//     // If there's no valid cached data, make the API call
//     const response = await axios.get( API_BASE_URL1 + `MasterDetails/GetAllFuelType`, {
//       headers: {
//         Authorization: `Bearer ${getToken()}`
//       }
//     });

//     // Store the data in session storage along with the current timestamp
//     sessionStorage.setItem(cacheKey, JSON.stringify(response.data));
//     sessionStorage.setItem(cacheExpiryKey, new Date().getTime() + cacheExpiryTime);

//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };


export const getVehicleByid = async (VehicleId) => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetVehicleByVehicleId?VehicleId=${VehicleId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
 